// extracted by mini-css-extract-plugin
module.exports =  {"volume-slider":"volume-slider-G_xAt"};